
import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { ReactNode } from 'react';

interface PaymentLayoutProps {
  children: ReactNode;
  onBack?: () => void;
  showBackButton?: boolean;
  title?: string;
  isProcessing?: boolean;
}

export default function PaymentLayout({ 
  children, 
  onBack, 
  showBackButton = true, 
  title = "Pagamento", 
  isProcessing = false 
}: PaymentLayoutProps) {
  // Check if we're in development/sandbox mode
  const isSandboxMode = window.location.hostname === 'localhost' || 
                        window.location.hostname.includes('.lovable.') ||
                        window.location.hostname.includes('.vercel.app');
  
  return (
    <div className="min-h-screen bg-muted/30">
      <header className="py-4 bg-white border-b border-border">
        <div className="container px-4 mx-auto">
          <div className="flex items-center justify-between">
            <img src="/brand/logo-secundario.svg" alt="dgenny" className="h-9" />

            {isSandboxMode && (
              <div className="flex items-center text-amber-700 bg-amber-50 border border-amber-200 px-3 py-1 rounded-full text-xs font-medium">
                <ShieldAlert size={14} className="mr-1.5" />
                <span>Ambiente de teste</span>
              </div>
            )}
          </div>
        </div>
      </header>

      <main className="container px-4 mx-auto py-12">
        <div className="max-w-3xl mx-auto">
          {showBackButton && onBack && (
            <div className="mb-6">
              <button
                onClick={onBack}
                disabled={isProcessing}
                className="inline-flex items-center text-brand-azul/70 hover:text-brand-roxo transition-colors text-sm font-medium"
              >
                <ArrowLeft size={16} className="mr-1" /> Voltar para configuração
              </button>
            </div>
          )}

          {title && <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-8">{title}</h1>}
          
          {isSandboxMode && (
            <div className="mb-6 p-4 border border-amber-200 bg-amber-50 rounded-md text-amber-700">
              <p className="flex items-center">
                <ShieldAlert size={18} className="mr-2" />
                <span>
                  <strong>Ambiente de teste:</strong> Pagamentos processados neste ambiente não são reais. Em produção, utilize um backend seguro para proteger suas credenciais de API.
                </span>
              </p>
            </div>
          )}

          {children}
        </div>
      </main>
    </div>
  );
}
